import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Eyebrow, Section } from './Section';
import { faqItems } from '../data/faq';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section tone="creme" labelledBy="faq-title" data-id="element-89" data-mp="1gdgzbbjl6g1o">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12" data-id="element-90" data-mp="1gal2jqjh5xet">
        <div className="lg:col-span-4" data-id="element-91" data-mp="2dz4whynv92e9">
          <Eyebrow data-id="element-92" data-mp="2dy3iblbjzzsb">Questions fréquentes</Eyebrow>
          <h2 id="faq-title" className="font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.5rem]" data-id="element-93" data-mp="292eidgvmggvh">
            Vos questions, nos réponses
          </h2>
        </div>

        <ul className="border-t border-warm-line lg:col-span-8" data-id="element-94" data-mp="1z2xd30ka8501">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <li key={item.question} className="border-b border-warm-line" data-id="element-95" data-mp="nn8qiaaxx7zr" data-mpi={index}>
                <h3 data-id="element-96" data-mp="pho9dqw2hklk">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-150 ease-out hover:text-warm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-graphite" data-id="element-97" data-mp="pj94piq7h7kh">
                    <span className="text-base font-medium leading-snug text-graphite md:text-lg" data-id="element-98" data-mp="bjpwkpxe9w86">
                      {item.question}
                    </span>
                    {isOpen ? <MinusIcon className="mt-1 h-4 w-4 shrink-0 text-warm" aria-hidden="true" data-id="element-99" data-mp="1sv8dg0l8mk3" /> : <PlusIcon className="mt-1 h-4 w-4 shrink-0 text-warm" aria-hidden="true" data-id="element-100" data-mp="3nz1ys2rdfmt4" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-101" data-mp="1pob8ax5xzckp">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-102" data-mp="1koyn0gupydk8">
                      <p className="max-w-prose pb-6 text-base leading-relaxed text-graphite-mid" data-id="element-103" data-mp="1zfe8zxuylpjg">
                        {item.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </Section>;
}